import { useRef } from 'react';

/**
 * Custom hook for dynamic date picker positioning
 * Returns a ref for the trigger button and a function to get optimal calendar position
 */
export const useDatePickerPosition = () => {
  const datePickerButtonRef = useRef(null);

  // Function to get calendar position relative to button
  const getCalendarPosition = () => {
    if (!datePickerButtonRef.current) {
      return { top: '50%', left: '50%', transform: 'translate(-50%, -50%)' };
    }

    const buttonRect = datePickerButtonRef.current.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // Calculate position below the button
    let top = buttonRect.bottom + 10;
    let left = buttonRect.left;

    // Adjust if calendar would go off screen
    const calendarWidth = 900; // approximate width
    const calendarHeight = 500; // approximate height

    // Adjust horizontal position if it goes off right edge
    if (left + calendarWidth > viewportWidth) {
      left = viewportWidth - calendarWidth - 20;
    }

    // Adjust horizontal position if it goes off left edge
    if (left < 20) {
      left = 20;
    }

    // Adjust vertical position if it goes off bottom edge
    if (top + calendarHeight > viewportHeight) {
      top = buttonRect.top - calendarHeight - 10;
    }

    // If still off screen, center it
    if (top < 20) {
      return { top: '50%', left: '50%', transform: 'translate(-50%, -50%)' };
    }

    return { top: `${top}px`, left: `${left}px`, transform: 'none' };
  };

  return {
    datePickerButtonRef,
    getCalendarPosition,
  };
};
